<script>
export default {
  props: ['size']
};
</script>
